import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UploadRepositoryService} from '@xmedical/core';
import {HttpMethod} from '../models/upload-type.type';
import {FileStorageProvider} from './file-storage.provider';

/**
 * Default FileStorageProvider that wraps UploadRepositoryService from @xmedical/core.
 * Targets the main API (port 5000). Used by xmedical-app, busamed-portal, etc.
 */
@Injectable()
export class CoreFileStorageProvider implements FileStorageProvider {
  private uploadRepo = inject(UploadRepositoryService);

  getSignedUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.uploadRepo.getSignedUrl(file, method, expires);
  }

  getSignedReportsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.uploadRepo.getSignedReportsUrl(file, method, expires);
  }

  getSignedUploadsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.uploadRepo.getSignedUploadsUrl(file, method, expires);
  }

  getSignedAssetsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.uploadRepo.getSignedAssetsUrl(file, method, expires);
  }
}
